import { useEffect } from 'react';
import { useSiteSettings } from './useSiteSettings';

export const useFavicon = () => {
  const { branding } = useSiteSettings();

  useEffect(() => {
    if (branding.favicon_url) {
      // Update all favicon references for search engines and browsers
      const faviconSelectors = [
        "link[rel='icon']",
        "link[rel='shortcut icon']",
        "link[rel='apple-touch-icon']"
      ];
      
      faviconSelectors.forEach(selector => {
        const links = document.querySelectorAll(selector);
        links.forEach(link => {
          (link as HTMLLinkElement).href = branding.favicon_url;
        });
      });
    }
  }, [branding.favicon_url]);
};
